<script lang="ts">
  import { flyAndScale } from '@/lib/utils/transitions'
  import { Dialog } from 'bits-ui'
  import { _ } from 'svelte-i18n'
  import { fade } from 'svelte/transition'
  import WarningIcon from './icons/warning.svelte'

  export let isOpen: boolean
  export let onConfirm: () => void
  export let onClose: () => void
  export let isLoading: boolean

  let inputValue = ''
  let error = ''
  $: {
    if (isOpen) {
      inputValue = ''
      error = ''
    }
  }

  function handleConfirm() {
    if (inputValue === 'DELETE') {
      onConfirm()
    } else {
      error = $_('dialog_delete_account_confirm_error')
    }
  }

  const message = $_('dialog_delete_account_confirm_plus_content', {
    values: {
      destruction_keyword: 'DELETE',
    },
  })
  let messageParts = message.split('DELETE')
  messageParts = [messageParts[0] ?? '', 'DELETE', messageParts[1] ?? '']
</script>

<Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
  <Dialog.Portal>
    <Dialog.Overlay
      class="fixed inset-0 z-50 bg-black/40"
      transition={fade}
      transitionConfig={{ duration: 150 }}
    />
    <Dialog.Content
      class="fixed left-[50%] top-[50%] z-50 w-[300px] max-w-[300px] translate-x-[-50%] translate-y-[-50%] rounded-lg bg-white p-4 text-center shadow-md"
      transition={flyAndScale}
    >
      <div class="space-y-3">
        <div class="flex justify-center">
          <WarningIcon />
        </div>
        <Dialog.Title class="text-lg font-semibold text-content-primary">
          {$_('dialog_delete_account_confirm_title')}
        </Dialog.Title>
        <Dialog.Description
          class="whitespace-pre-line text-sm text-content-secondary"
        >
          {#each messageParts as part}
            {#if part === 'DELETE'}
              <span class="font-bold">DELETE</span>
            {:else}
              {part}
            {/if}
          {/each}
        </Dialog.Description>
      </div>
      <div class="mt-3 space-y-3">
        <input
          type="text"
          class="h-11 w-full rounded-2xl bg-[#F4F4F4] px-3 text-sm text-content-primary"
          bind:value={inputValue}
          on:focus={() => {
            error = ''
          }}
          on:input={() => {
            error = ''
          }}
        />
        {#if error}
          <p class="text-left text-xs text-[#E84841]">
            {error}
          </p>
        {/if}
      </div>
      <div class="mt-4 flex flex-col space-y-3 text-white">
        <button
          class="h-10 w-full rounded-md bg-[#F26663] shadow-[0_4px_0_#DB3329]"
          disabled={isLoading}
          on:click={handleConfirm}
        >
          {$_('btn_confirm_delete')}
        </button>
        <button
          disabled={isLoading}
          class="h-10 w-full rounded-md bg-[#C9C9C9] shadow-[0_4px_0_#888888]"
          on:click={onClose}
        >
          <span>{$_('btn_cancel')}</span>
        </button>
      </div>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>
